import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";

const onError = (event: ErrorEvent) => {
  if (window.parent !== window) {
    window.parent.postMessage(
      {
        channel: "errorLog",
        message: event.message,
        source: event.filename,
        line: event.lineno,
        col: event.colno,
      },
      "*"
    );
  }
};

const onUnhandledRejection = (event: PromiseRejectionEvent) => {
  if (window.parent !== window) {
    const reason = event.reason;
    window.parent.postMessage(
      {
        channel: "errorLog",
        message: reason instanceof Error ? reason.message : String(reason),
      },
      "*"
    );
  }
};

window.addEventListener("error", onError);
window.addEventListener("unhandledrejection", onUnhandledRejection);

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    window.removeEventListener("error", onError);
    window.removeEventListener("unhandledrejection", onUnhandledRejection);
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
